import { TOKEN_KEY } from '@features/auth/utils/constants'
import type { AxiosInstance, AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios'
import Axios from 'axios'

export const apiClient: AxiosInstance = Axios.create({
  baseURL: import.meta.env['VITE_API_URL'] || '',
})

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const newConfig: InternalAxiosRequestConfig = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
    } as unknown as AxiosRequestHeaders,
  }
  return newConfig
})

export const v2Client: AxiosInstance = Axios.create({
  baseURL: import.meta.env['VITE_API_URL_V2'] || '/api/v2',
  headers: {
    'Content-Type': 'application/json',
  },
})

v2Client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const newConfig: InternalAxiosRequestConfig = {
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
    } as unknown as AxiosRequestHeaders,
  }
  return newConfig
})

export const authClient: AxiosInstance = Axios.create({
  baseURL: import.meta.env['VITE_AUTH_API_URL'] || '/',
})
